/**
 * Toast hook + context. The Snackbar UI lives in
 * `src/components/ui/SnackbarProvider.tsx`; outside the provider (tests),
 * `useToast` degrades to a no-op.
 */
import { createContext, useContext } from "react";
import type { AlertColor } from "@mui/material";

export type ToastFn = (message: string, severity?: AlertColor) => void;

export const ToastContext = createContext<ToastFn>(() => undefined);

export function useToast(): ToastFn {
  return useContext(ToastContext);
}
